/**
 * UI chrome for V2 S1/S2 — maps Assets option ids → legacy intake hint/help keys.
 * Answer payloads stay on V2 ids (SELF_ONLY, …); this file is presentation only.
 */

/** V2 S1 option id → intake.participants / participantHints / participantHelpText key */
export const S1_TO_LEGACY_UI_KEY = {
  SELF_ONLY: 'SELF',
  INTIMATE_PARTNERS: 'COUPLE',
  // CHILD_ALONE is ages 0–17 — do not reuse legacy under-12 CHILD hints
  CHILD_ALONE: null,
  PARENT_CONSULT: 'PARENT',
  PARENT_AND_CHILD: 'PARENT_AND_CHILD',
  FAMILY_MEMBERS: 'FAMILY',
}

/** Extra copy for V2-only intents (not in legacy PARTICIPANT_KEYS). */
export const S1_EXTRA_HINTS = {
  CHILD_ALONE: 'کمک به کودک یا نوجوان برای احساسات، رفتار و چالش‌های روزمره؛ ۰ تا ۱۷ سال',
  PARENT_CONSULT: 'راهنمایی والد برای همراهی با فرزند و چالش‌های فرزندپروری',
  PARENT_AND_CHILD: 'کار روی ارتباط و مشکلات مشترک با حضور والد و فرزند',
  FAMILY_MEMBERS: 'کار روی ارتباط‌ها، تعارض‌ها و مسائل مشترک خانواده',
}

export const S1_EXTRA_HELP = {
  CHILD_ALONE:
    'درمان با تمرکز بر نیازهای خود کودک یا نوجوان پیش می‌رود. سن ثبت‌شده مربوط به همان مراجع است (۰ تا ۱۷)؛ نقش والد و رضایت لازم بر اساس مسیر خدمت مشخص می‌شود.',
  PARENT_CONSULT:
    'والد در جلسه شرکت می‌کند تا برای شناخت نیازهای فرزند، شیوهٔ همراهی و مدیریت موقعیت‌های دشوار راهنمایی بگیرد؛ این گزینه با درمان مستقیم فرزند تفاوت دارد.',
  PARENT_AND_CHILD:
    'والد و فرزند با هم در جلسه شرکت می‌کنند تا روی رابطه و مشکلات مشترک کار کنند. سن ثبت‌شده مربوط به فرزند است.',
  FAMILY_MEMBERS:
    'اعضای خانواده برای بررسی الگوهای ارتباطی و حل مسائل مشترک در جلسه شرکت می‌کنند؛ این گزینه صرفاً چند درمان فردی جداگانه نیست.',
}

export const S1_EXTRA_HINTS_EN = {
  CHILD_ALONE: 'Support with emotions, behaviour and everyday challenges for a child or adolescent aged 0–17',
  PARENT_CONSULT: 'Guidance for a parent on supporting their child and parenting challenges',
  PARENT_AND_CHILD: 'Work on the relationship and shared difficulties with parent and child together',
  FAMILY_MEMBERS: 'Work on communication, conflict and shared family concerns',
}

export const S1_EXTRA_HELP_EN = {
  CHILD_ALONE: 'Care focuses on the child or adolescent’s own needs. Enter their age (0–17); parental involvement and consent are determined by the service path.',
  PARENT_CONSULT: 'The parent attends to discuss their child’s needs, ways to support them and difficult parenting situations. This differs from direct therapy for the child.',
  PARENT_AND_CHILD: 'Parent and child attend together to work on their relationship and shared difficulties. Enter the child’s age.',
  FAMILY_MEMBERS: 'Family members attend to explore communication patterns and shared concerns, rather than attending separate individual therapies.',
}

export function legacyUiKeyForS1(optionId) {
  return S1_TO_LEGACY_UI_KEY[optionId] || null
}

export function toAsciiDigits(value) {
  const map = {
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
  }
  return String(value || '').replace(/[۰-۹٠-٩]/g, (digit) => map[digit] || digit)
}

export function parseAgeInput(value) {
  const raw = toAsciiDigits(value).replace(/[^\d]/g, '')
  if (!raw) {
    return null
  }
  return Number(raw)
}
